module.exports = __webpack_public_path__ + "img/tyre_icon.50393ce3.png";